export function download(fileLink) {
  // Create a link and set the URL using `createObjectURL`
  const link = document.createElement("a")
  link.style.display = "none"
  link.href = fileLink
  link.target = "_blank"

  // It needs to be added to the DOM, so it can be clicked
  document.body.appendChild(link)
  link.click()

  // To make this work on Firefox we need to wait
  // a little while before removing it.
  setTimeout(() => {
    link.parentNode.removeChild(link)
  }, 50)
}

export function downloadFromArrayBuffer(arrayBuffer, fileName) {
  // Create a link and set the URL using `createObjectURL`
  const blob = new Blob([arrayBuffer], { type: "application/pdf" })
  const url = URL.createObjectURL(blob)
  const link = document.createElement("a")
  link.href = url
  link.download = fileName

  document.body.appendChild(link)
  link.click()

  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
